import { render, staticRenderFns } from "./SupplierDropdown.vue?vue&type=template&id=8373d2a4&"
import script from "./SupplierDropdown.vue?vue&type=script&lang=js&"
export * from "./SupplierDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports